import { z } from "zod";

const SEMVER_RE = /^\d+\.\d+\.\d+(?:[-+][0-9A-Za-z.-]+)?$/;

export const uploadPiOtaReleaseSchema = z.object({
  // Optional — leave blank to auto-bump patch from latest release.
  // Set explicitly for minor/major bumps (e.g. "1.1.0", "2.0.0").
  version: z
    .string()
    .regex(SEMVER_RE, "Version must look like 1.2.3 (semver)")
    .optional()
    .or(z.literal("")),
  releaseNotes: z.string().optional(),
  file: z
    .any()
    .refine((val) => val instanceof FileList && val.length > 0, {
      message: "ZIP file is required",
    })
    .refine(
      (val) =>
        val instanceof FileList &&
        val.length > 0 &&
        /\.zip$/i.test(val[0].name),
      { message: "File must be a .zip" }
    ),
});

export type UploadPiOtaReleaseFormData = z.infer<
  typeof uploadPiOtaReleaseSchema
>;

export interface PiOtaRelease {
  id: string;
  version: string;
  sha256: string;
  sizeBytes: number;
  releaseNotes: string | null;
  isActive: boolean;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PiOtaReleaseListResult {
  releases: PiOtaRelease[];
}

export interface UploadPiOtaReleaseInput {
  file: File;
  /** Optional — backend auto-bumps patch when omitted. */
  version?: string;
  releaseNotes?: string;
  activate?: boolean;
}

export interface UploadPiOtaReleasePayload {
  input: UploadPiOtaReleaseInput;
}
